export const columns = [
  {
    dataField: 'name',
    text: 'Report Name',
    sortable: true,
    sortBy: 'name',
  },
  {
    dataField: 'cadence',
    text: 'Cadence',
    sortable: true,
    sortBy: 'cadence',
  },
  {
    dataField: 'time_period',
    text: 'Time Period',
    sortable: true,
    sortBy: 'date_from',
  },
  {
    dataField: 'benchmark_app',
    text: 'Benchmark App',
    sortable: false,
  },
  {
    dataField: 'actions',
    text: '',
    sortable: false,
  },
];
